import { Moon } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MoonIcon = createLucideIcon(Moon);
